/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from "react";
import {useSelectFileUploadResponse} from "../../../../redux/ducks/Wizard/SliceProvider";
import TemplateStep from "../../../components/Wizard/Steps/TemplateStep";
import {IBaseStepProps} from "../../../components/Wizard/types";
import Plotly2DTracesSide from "../Plots/Plotly2DTracesSide";

const Step2DTracesSide = (props: IBaseStepProps) => {
  const {messagesTitle} = props
  const response = useSelectFileUploadResponse()
  const plotlyTraces = response?.cosmos_data?.sensors_data_map
  const dimensionsList = response?.cosmos_data?.metadata?.dimensions_list

  const content2 = (
    <div>
      <Plotly2DTracesSide plotlyTraces={plotlyTraces} dimensionsList={dimensionsList}/>
    </div>
  )
  return (
    <>
      <TemplateStep content1={null} content2={content2} errorMessages={[]}
                    messagesTitle={messagesTitle} isFirstWizardStep={false} isLastWizardStep={false}
                    customTopRow={null}
      />
    </>
  );
};

export default Step2DTracesSide